import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from 'components/atoms/Button';
import { ReactComponent as CloseIcon } from 'assets/images/close-icon.svg';
import { ReactComponent as BigCloseIcon } from 'assets/images/big_close.svg';

import {
  Wrapper,
  Body,
  Content,
  Footer,
  Header,
  ConfigMobileHeader,
  ConfigMobileImgWrapper,
  BigClose,
} from './styled';
import { Divider } from '../../atoms/styleds';

const getButtonConfigs = (variant) => {
  switch (variant) {
    case 'update':
      return {
        actionText: 'Chiudi ora',
        cancelText: 'Annulla',
        buttonColor: 'danger',
      };
    case 'config':
      return {
        actionText: 'Conferma',
        cancelText: 'Annulla',
        buttonColor: 'action',
      };
    default:
      return {
        actionText: 'Conferma',
        cancelText: 'Annulla',
        buttonColor: 'action',
      };
  }
};

const Modal = ({
  desktopMinH,
  open,
  title,
  body,
  variant = 'update',
  onClose,
  onCancel,
  onSubmit,
  disabled,
  inProcess,
  actionButtonText,
  cancelButtonText,
  desktopW,
  showDivider,
  primaryHeader = false,
  actionButtonColor,
  headerCenter,
  hideHeaderDivider = false,
  bodyMb,
  disabledCancel = false,
  forceHideButtons = false,
  hideCancelButton = false,
  btnMaxWidth = '155px',
}) => {
  useEffect(() => {
    const body = document.querySelector('body');
    if (open) {
      body.style.overflow = 'hidden';
    } else {
      body.style.overflow = 'auto';
    }

    return () => {
      body.style.overflow = 'auto';
    };
  }, [open]);

  const { cancelText, actionText, buttonColor } = getButtonConfigs(variant);
  return (
    <Wrapper open={open} onClick={() => onClose && onClose()}>
      <Content
        desktopW={desktopW}
        onClick={(e) => e.stopPropagation()}
        variant={variant}
      >
        <Header
          primaryHeader={primaryHeader}
          showDivider={
            !hideHeaderDivider && (variant === 'config' || showDivider)
          }
          headerCenter={headerCenter}
        >
          {title}
          {variant === 'config' && (
            <ConfigMobileHeader>
              <ConfigMobileImgWrapper role='presentation' onClick={onClose}>
                <CloseIcon />
              </ConfigMobileImgWrapper>
            </ConfigMobileHeader>
          )}
          {primaryHeader && (
            <BigClose role='presentation' onClick={onClose} as={BigCloseIcon} />
          )}
        </Header>
        <Body mb={bodyMb} desktopMinH={desktopMinH} variant={variant}>
          {body}
        </Body>
        <Footer>
          {!forceHideButtons && (
            <>
              {!hideCancelButton && (
                <Button
                  disabled={inProcess || disabledCancel}
                  onClick={onCancel}
                  flex={1}
                  color='cancel'
                  maxW='155px'
                  mr={10}
                  isCancel={true}
                >
                  {cancelButtonText || cancelText}
                </Button>
              )}
              <Button
                disabled={inProcess || disabled}
                loading={inProcess}
                onClick={onSubmit}
                color={actionButtonColor || buttonColor}
                flex={1}
                maxW={btnMaxWidth}

              >
                {actionButtonText || actionText}
              </Button>
            </>
          )}
        </Footer>
      </Content>
    </Wrapper>
  );
};

export const PrimaryModal = ({
  open,
  onClose,
  title,
  body,
  footer,
  inProcess,
  hideFooter,
  onCancel,
  disabledCancel,
  cancelButtonText,
  cancelText,
  disabled,
  onSubmit,
  buttonColor,
  desktopMinH,
  desktopMaxH,
  actionButtonText,
  actionText,
  desktopW,
  showDivider,
  cancelButtonColor,
  bodyMb,
  children,
  primaryHeader = true,
  showFooterDivider = false,
  variant = 'config',
  forceHeight,
}) => {
  useEffect(() => {
    const body = document.querySelector('body');
    if (open) {
      body.style.overflow = 'hidden';
    } else {
      body.style.overflow = 'auto';
    }

    return () => {
      body.style.overflow = 'auto';
    };
  }, [open]);

  // console.log('desktopMinH', desktopMinH);

  return (
    <Wrapper open={open} onClick={() => onClose && onClose()}>
      <Content
        variant={variant}
        onClick={(e) => e.stopPropagation()}
        desktopW={desktopW}
      >
        <Header primaryHeader={primaryHeader} showDivider={showDivider}>
          {title}
          <BigClose role='presentation' onClick={onClose} as={BigCloseIcon} />
          <ConfigMobileHeader>
            <ConfigMobileImgWrapper role='presentation' onClick={onClose}>
              <CloseIcon />
            </ConfigMobileImgWrapper>
          </ConfigMobileHeader>
        </Header>
        <Body
          variant={variant}
          desktopMaxH={desktopMaxH}
          desktopMinH={desktopMinH}
          forceHeight={forceHeight}
          mb={bodyMb}
        >
          {children || body}
        </Body>
        <div>
          {showFooterDivider && <Divider mb={20} mobileMb={20} />}
          <Footer>
            {!hideFooter &&
              (footer || (
                <>
                  {(cancelButtonText || cancelText) && (
                    <Button
                      disabled={inProcess || disabledCancel}
                      onClick={onCancel}
                      flex={1}
                      color={cancelButtonColor || 'cancel'}
                      maxW='155px'
                      mr={10}
                      isCancel={true}
                    >
                      {cancelButtonText || cancelText}
                    </Button>
                  )}
                  <Button
                    disabled={inProcess || disabled}
                    loading={inProcess}
                    onClick={onSubmit}
                    color={buttonColor}
                    flex={1}
                    maxW='155px'
                  >
                    {actionButtonText || actionText}
                  </Button>
                </>
              ))}
          </Footer>
        </div>
      </Content>
    </Wrapper>
  );
};

Modal.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  cancelButtonText: PropTypes.string,
  actionButtonText: PropTypes.string,
  body: PropTypes.any,
  variant: PropTypes.oneOf(['update', 'delete', 'primary', 'config']),
  onClose: PropTypes.func,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  inProcess: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default Modal;
